import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectLinkedInButton from "./ConnectLinkedInButton";
import { linkedInReplyState } from "./state";
import ConnectedLinkedInList from "./ConnectedLinkedInList";
import ConnectedLinkedInConfigure from "./ConnectedLinkedInConfigure";

const LinkedInAccounts = observer((props = {}) => {
  useEffect(() => {
    // This page also doubles as the landing target for the LinkedIn OAuth
    // redirect (Unipile sends the browser back here on both success and
    // failure via `li.connection.page.url`). The actual LinkedinAccount
    // record is created/updated asynchronously by the backend's Unipile
    // webhook, so on every mount we poll briefly rather than fetching once —
    // this is a no-op extra call on a normal visit, but catches the account
    // showing up shortly after an OAuth round-trip.
    linkedInReplyState.pollForLinkedInAccountAfterOAuth();
  }, []);

  return (
    <div
      className={`connectLinkedInBody ${
        linkedInReplyState?.linkedInConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {linkedInReplyState?.linkedInConnected ? (
        linkedInReplyState?.showConfigure ? (
          <ConnectedLinkedInConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            {/* <ConnectedLinkedInHeader /> */}
            <ConnectedLinkedInList />
          </div>
        )
      ) : (
        <ConnectLinkedInButton />
      )}
    </div>
  );
});

export { LinkedInAccounts };
export default LinkedInAccounts;
